// src/components/canine-teeth/SavedSessionsGallery.js

import React, { useEffect, useState } from 'react';
import { getSessionsByEmailAndTool, deleteSession } from '../../indexedDB'; // Import the new function
import PropTypes from 'prop-types';
import '../tools.css';
const tool = 'carpal-bones'; // Specify the desired tool

function SavedSessionsGallery({ onSelectSession, sessionsCount, userEmail }) {
  const [savedSessions, setSavedSessions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchSessions = async () => {
      setIsLoading(true);
      setError(null);
      try {
        
  const sessions = await getSessionsByEmailAndTool(userEmail, tool); // Use the new function
  console.log('Sessions recovered:', sessions);
        setSavedSessions(sessions);
      } catch (error) {
  console.error('Error fetching sessions:', error);
  setError('Error fetching sessions. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    if (userEmail) { // Assicurati di avere l'email dell'utente prima di chiamare fetchSessions
      fetchSessions();
    } else {
      setSavedSessions([]);
      setIsLoading(false);
    }
  }, [sessionsCount, userEmail]);

  const handleDeleteSession = async (sessionName) => {
    try {
      await deleteSession(sessionName, userEmail); // Passa anche userEmail
      // Aggiorna lo stato delle sessioni dopo la cancellazione
      setSavedSessions((prevSessions) =>
        prevSessions.filter((session) => session.subImage.name !== sessionName)
      );
    } catch (error) {
      console.error('Error deleting session:', error);
      alert('An error occurred while deleting the session. Please try again.');
    }
  };

  if (isLoading) {
    return <div className="loading-container">Loading sessions...</div>;
  }

  if (error) {
    return <div className="error-container">{error}</div>;
  }

  if (savedSessions.length === 0) {
    return <div className="no-sessions">No saved sessions for the selected tool.</div>;
  }

  return (
    <div className="gallery-container">
      <h3 className="gallery-title">Saved sessions</h3>
      <div className="gallery-grid">
        {savedSessions.map((session) => {
              // Verify that the session is valid
          if (
            !session ||
            !session.subImage ||
            !session.subImage.dataURL ||
            typeof session.subImage.dataURL !== 'string' ||
            !session.subImage.dataURL.startsWith('data:image')
          ) {
            console.error('Invalid session or image unavailable:', session);
            return (
              <div key={session.id || session.subImage.name} className="gallery-card invalid-session">
                <p>Session data invalid or image unavailable.</p>
                <button
                  onClick={() => handleDeleteSession(session.subImage.name)}
                  className="delete-button"
                >
                  Delete
                </button>
              </div>
            );
          }

          return (
            <div key={session.id} className="gallery-card">
              <img
                src={session.subImage.dataURL}
                alt={`Session ${session.id}`}
                className="gallery-image"
                onClick={() => onSelectSession(session)}
              />
              <p className="gallery-image-name">{session.subImage.name}</p>
              <button
                onClick={() => handleDeleteSession(session.subImage.name)}
                className="delete-button"
              >
                Delete
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// Definizione dei tipi delle props per una migliore manutenibilità e debugging
SavedSessionsGallery.propTypes = {
  onSelectSession: PropTypes.func.isRequired,
  sessionsCount: PropTypes.number.isRequired,
  userEmail: PropTypes.string.isRequired,
};

export default SavedSessionsGallery;
